import Vue from 'vue'

export async function getIngresos(context, [access_token, params, loading]) {
    try {
        if (access_token) {
            if (loading){
                context.commit('setLoading', true, { root: true })
            }
            const response = await Vue.axios({
                method: 'GET',
                url: '/ingresos',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                params: params
            })
            context.commit('ingresos/setIngresos', response.data.data, { root: true })
        }

    } catch (e) {
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}